import { createSlice } from "@reduxjs/toolkit";
import { logout } from "./AuthSlice";

const toastSlice = createSlice({
    name : 'toast',
    initialState : {
       showToast : false,
       color : '#138708',
       message : '',
       timeOut : 5000
    },
    reducers : {
        setSnackBar(state, {payload}) { 
            state.message = payload.message;

            if(payload.color === 'success')
                state.color = '#138708';
            else if(payload.color === 'error')
                state.color = '#B82626';
            else
                state.color = payload.color;
            state.showToast = true;
        },

        closeSnackBar(state) {
            state.showToast = false;
            state.color = 'success';
            state.message = '';
        },
    },

    extraReducers : (builder) => {
        builder.addCase(logout, (state) => {
            state.color = '#138708';
            state.message = 'You are logged out!';
            state.showToast = true
        })
    }
});

export default toastSlice.reducer;
export const { setSnackBar, closeSnackBar } = toastSlice.actions;